import { render, staticRenderFns } from "./MenuDigital.vue?vue&type=template&id=781f4f16&scoped=true&"
import script from "./MenuDigital.vue?vue&type=script&lang=js&"
export * from "./MenuDigital.vue?vue&type=script&lang=js&"
import style0 from "./MenuDigital.vue?vue&type=style&index=0&id=781f4f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f4f16",
  null
  
)

export default component.exports